/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const ROLE_DESCRIPTION_REQUIRED = 'Role description required';
export const ROLE_NAME_REQUIRED = 'Role name required';
export const ROLE_IS_SAVED_SUCCESSFULLY = 'Role {0} is saved successfully';
export const ROLE_CREATE_FAILED = 'Error in creating role: {0}';
export const EDIT_ROLE = 'Edit Role';
export const ADD_ROLE = 'Add Role';
export const CREATE_ROLE_BTN = 'createRoleBtn';
export const DISPLAY_NAME = 'displayName';
export const NAME = 'Name*';
export const DESCRIPTION = 'DESCRIPTION*';
export const DESCRIPTION_NAME = 'description';
export const GLOBAL_ROLE_CHECKBOX = "global-role-checkbox";
export const ORGANIZATION = "Organization*";
export const APPLICATION = "Application*";
export const MODULE = "Module*";
export const SAVE = "Save";
export const CANCEL = "Cancel";
export const MODULE_REQUIRED = "Module is required.";
export const POLICY_TYPE_GLOBAL = "global";
export const ORGANIZATION_KEY = "organization";
export const APPLICATION_KEY = "application";
export const MODULE_KEY = "module";
export const NAME_KEY = "name";

export const AdminRealmIdList = [
  { realmId: '7520eb93-b0a8-432f-9c94-c9583a470222' }, // liam-test
  { realmId: '3d30d779-743a-41a8-bb78-22405300fb96' },// liam-us
  { realmId: '00ca84fa-534b-4af3-841d-10704eb35c40' }, // liam-apac
  { realmId: '57bfe6c3-73ec-49ec-a627-e792133247a6' }, // liam-eu
  { realmId: 'f1635f28-665b-4577-b965-c2338b33f09c' }, // liam-dev
];